module.exports = __webpack_public_path__ + "media/images/application/template/download-5080d74322b95ebf58828c67f50152b0.png";